/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _circle8, _circle9, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _circle0, _circle1, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _circle10, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _circle11, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _circle12, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _circle13, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376;
const SoilMoistureGlobal = /*#__PURE__*/React.forwardRef(function SoilMoistureGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a4.7347,4.7347,0,0,1-4.2075-7.35l3.3687-5.1942a1,1,0,0,1,1.6779,0l3.3152,5.11A4.9753,4.9753,0,0,1,30,25.2231,4.8979,4.8979,0,0,1,25,30Zm0-10.1629-2.5078,3.8662A2.9264,2.9264,0,1,0,28,25.2231a2.96,2.96,0,0,0-.5444-1.6028Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24H14A12.0137,12.0137,0,0,1,26,12h4v2H26A10.0113,10.0113,0,0,0,16,24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilMoistureGlobal.propTypes = iconPropTypes;
}
const SoilTemperature = /*#__PURE__*/React.forwardRef(function SoilTemperature({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "13",
    r: "1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "19",
    r: "1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "25",
    r: "1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "15",
    r: "1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "11",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "21",
    r: "1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H30V8H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilTemperature.propTypes = iconPropTypes;
}
const SoilTemperatureField = /*#__PURE__*/React.forwardRef(function SoilTemperatureField({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16V11h1a4.0045,4.0045,0,0,0,4-4V4H13a3.9779,3.9779,0,0,0-2.7468,1.1067A6.0034,6.0034,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.002,2.002,0,0,1,13,6ZM8,9A4.0045,4.0045,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H16V23H2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H16V28H2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilTemperatureField.propTypes = iconPropTypes;
}
const SoilTemperatureGlobal = /*#__PURE__*/React.forwardRef(function SoilTemperatureGlobal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a4.9863,4.9863,0,0,1-3-8.98V15a3,3,0,0,1,6,0v6.02A4.9863,4.9863,0,0,1,25,30Zm0-16a1.0011,1.0011,0,0,0-1,1v7.13l-.4971.2893A2.9676,2.9676,0,0,0,22,25a3,3,0,0,0,6,0,2.9676,2.9676,0,0,0-1.5029-2.5811L26,22.13V15A1.0011,1.0011,0,0,0,25,14Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24H14a11.89,11.89,0,0,1,3.7642-8.7271l1.373,1.4542A9.909,9.909,0,0,0,16,24Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11,24H9A17.0192,17.0192,0,0,1,26,7h4V9H26A15.017,15.017,0,0,0,11,24Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2A21.8625,21.8625,0,0,0,13.9993,5.5757,21.856,21.856,0,0,0,2,2V4A19.8735,19.8735,0,0,1,12.2622,6.835,22.1514,22.1514,0,0,0,9.9475,8.979,17.001,17.001,0,0,0,2,7V9a15.0142,15.0142,0,0,1,6.6191,1.5366,22.0768,22.0768,0,0,0-1.7016,2.5371A12.0319,12.0319,0,0,0,2,12v2a9.8838,9.8838,0,0,1,4.0007.8506A21.861,21.861,0,0,0,4,24H6A20.0226,20.0226,0,0,1,26,4h4V2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilTemperatureGlobal.propTypes = iconPropTypes;
}
const SolarPanel = /*#__PURE__*/React.forwardRef(function SolarPanel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30,26V14H13V26h5v2H2v2H30V28H25V26Zm-5-2V21h3v3Zm-2-3v3H20V21Zm-3-2V16h3v3Zm8,0H25V16h3ZM18,16v3H15V16Zm-3,8V21h3v3Zm8,4H20V26h3Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3328,14.981A4,4,0,1,1,16,12H14a2,2,0,1,0-3.3333,1.4907Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H13V6H11z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H6V13H2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.343 4.343H7.343V8.343H5.343z",
    transform: "rotate(-45 6.343 6.343)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.657 4.343H18.657V8.343H16.657z",
    transform: "rotate(-135 17.657 6.343)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SolarPanel.propTypes = iconPropTypes;
}
const SortAscending = /*#__PURE__*/React.forwardRef(function SortAscending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H16V20H2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H16V8H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortAscending.propTypes = iconPropTypes;
}
const SortDescending = /*#__PURE__*/React.forwardRef(function SortDescending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22L19.414 20.586 23 24.172 23 4 25 4 25 24.172 28.586 20.586 30 22 24 28 18 22z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H16V8H2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H16V20H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortDescending.propTypes = iconPropTypes;
}
const SortRemove = /*#__PURE__*/React.forwardRef(function SortRemove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.415L28.586 18 25 21.587 21.414 18 20 19.415 23.586 23 20 26.586 21.414 28 25 24.414 28.586 28 30 26.586 26.414 23 30 19.415z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H16V20H10z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H16V8H2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H16V14H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortRemove.propTypes = iconPropTypes;
}
const SortingAToZ = /*#__PURE__*/React.forwardRef(function SortingAToZ({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11,13c0-1.103-.8975-2-2-2h-5v2h5v2h-4c-1.1046,0-2,.8954-2,2v2c0,1.1046.8954,2,2,2h6v-8ZM9,19h-4v-2h4v2ZM16,2l-5,6h10l-5-6ZM16,30l5-6h-10l5,6ZM29,11h-8v2h5.5l-5.5,6v2h8v-2h-5.4927l5.4927-6v-2ZM19,17v-2h-6v2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortingAToZ.propTypes = iconPropTypes;
}
const SortingHighestToLowestNumber = /*#__PURE__*/React.forwardRef(function SortingHighestToLowestNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9756,2l-5,6h10l-5-6ZM15.9756,30l5-6h-10l5,6ZM24.9756,19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2ZM10.9756,19h-4v-2h2c1.1025,0,2-.897,2-2v-2c0-1.103-.8975-2-2-2h-4v2h4v2h-2c-1.103,0-2,.897-2,2v4h6v-2ZM18.9756,17v-2h-6v2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortingHighestToLowestNumber.propTypes = iconPropTypes;
}
const SortingLowestToHighestNumber = /*#__PURE__*/React.forwardRef(function SortingLowestToHighestNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9756,2l-5,6h10l-5-6ZM15.9756,30l5-6h-10l5,6ZM10.9756,19h-2v-8h-2v1h-2v2h2v5h-2v2h6v-2ZM24.9756,17c1.1025,0,2-.897,2-2v-2c0-1.103-.8975-2-2-2h-4v2h4v2h-2c-1.103,0-2,.897-2,2v4h6v-2h-4v-2h2ZM18.9756,17v-2h-6v2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortingLowestToHighestNumber.propTypes = iconPropTypes;
}
const SortingZToA = /*#__PURE__*/React.forwardRef(function SortingZToA({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11h-5v2h5v2h-4c-1.1046,0-2,.8954-2,2v2c0,1.1046.8954,2,2,2h6v-8c0-1.103-.8975-2-2-2ZM27,19h-4v-2h4v2ZM16,2l-5,6h10l-5-6ZM16,30l5-6h-10l5,6ZM11,19h-5.4927l5.4927-6v-2H3v2h5.5l-5.5,6v2h8v-2ZM19,17v-2h-6v2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SortingZToA.propTypes = iconPropTypes;
}
const SpellCheck = /*#__PURE__*/React.forwardRef(function SpellCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22h2L17,10H15L10,22h2l1.24-3h5.53Zm-5.93-5,1.82-4.42h.25L18,17Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V17H26V6H6V26h6Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SpellCheck.propTypes = iconPropTypes;
}
const WatsonHealthSpineLabel = /*#__PURE__*/React.forwardRef(function WatsonHealthSpineLabel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11L3 13 8.59 13 2.29 19.29 3.71 20.71 10 14.41 10 20 12 20 12 11 3 11z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13H23V12H21v1H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h3v1h2V19h3a2,2,0,0,0,2-2V15A2,2,0,0,0,26,13Zm-8,4V15h8v2Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26,23H23V22H21v1H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h3v1h2V29h3a2,2,0,0,0,2-2V25A2,2,0,0,0,26,23Zm-8,4V25h8v2Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26,3H23V2H21V3H18a2,2,0,0,0-2,2V7a2,2,0,0,0,2,2h3v1h2V9h3a2,2,0,0,0,2-2V5A2,2,0,0,0,26,3ZM18,7V5h8V7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSpineLabel.propTypes = iconPropTypes;
}
const Split = /*#__PURE__*/React.forwardRef(function Split({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V24H15z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14H17V18H15z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V12H15z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Split.propTypes = iconPropTypes;
}
const WatsonHealthSplitDiscard = /*#__PURE__*/React.forwardRef(function WatsonHealthSplitDiscard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16A12.01,12.01,0,0,0,17,4.0508V2H15V4.0508a11.99,11.99,0,0,0,0,23.8984V30h2V27.9492A12.01,12.01,0,0,0,28,16ZM16,26V6a10,10,0,0,1,0,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSplitDiscard.propTypes = iconPropTypes;
}
const SplitScreen = /*#__PURE__*/React.forwardRef(function SplitScreen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V28H15z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10,7V25H4V7h6m0-2H4A2,2,0,0,0,2,7V25a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7V25H22V7h6m0-2H22a2,2,0,0,0-2,2V25a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SplitScreen.propTypes = iconPropTypes;
}
const SprayPaint = /*#__PURE__*/React.forwardRef(function SprayPaint({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,23A4.5,4.5,0,1,1,27,18.5,4.505,4.505,0,0,1,22.5,23Zm0-7A2.5,2.5,0,1,0,25,18.5,2.5026,2.5026,0,0,0,22.5,16Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H26V3H19V8H17a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM21,5h3V8H21ZM17,28V10H28l.002,18Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H5V17H2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9H10V12H7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H5V12H2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H15V7H12z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4H10V7H7z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H5V7H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SprayPaint.propTypes = iconPropTypes;
}
const Sprout = /*#__PURE__*/React.forwardRef(function Sprout({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2A11.01,11.01,0,0,0,14.7549,9.0244,6.9939,6.9939,0,0,0,9,6H6V9a7.0078,7.0078,0,0,0,7,7h1v9.0493a9.9229,9.9229,0,0,0-6.071,2.8794l1.414,1.4141a8,8,0,0,1,12.3086,1.2134l1.6616-1.1128A9.98,9.98,0,0,0,16,25.062V16h1A11.0125,11.0125,0,0,0,28,5V2ZM13,14A5.0057,5.0057,0,0,1,8,9V8H9a5.0054,5.0054,0,0,1,5,5v1ZM26,5a9.01,9.01,0,0,1-9,9H16V13a9.01,9.01,0,0,1,9-9h1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sprout.propTypes = iconPropTypes;
}
const SpyreAccelerator = /*#__PURE__*/React.forwardRef(function SpyreAccelerator({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M7,17c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM7,13c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM13,17c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM13,13c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM25,17c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM25,13c.5522,0,1-.4476,1-1s-.4478-1-1-1-1,.4478-1,1,.4477,1,1,1ZM2,7v17h6v-3h3v4h16v-4h3V7H2ZM25,23h-12v-2h12v2ZM28,19H6v3h-2v-13h24v10ZM22,11h-6v6h6v-6ZM20,15h-2v-2h2v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SpyreAccelerator.propTypes = iconPropTypes;
}
const Sql = /*#__PURE__*/React.forwardRef(function Sql({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21L24 9 22 9 22 23 30 23 30 21 24 21z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h1v2a2,2,0,0,0,2,2h2V25H17V23h1a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9ZM14,21V11h4V21Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8,23H2V21H8V17H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9h6v2H4v4H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sql.propTypes = iconPropTypes;
}
const SquareOutline = /*#__PURE__*/React.forwardRef(function SquareOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m26,4H6c-1.1046,0-2,.8954-2,2v20c0,1.1046.8954,2,2,2h20c1.1046,0,2-.8954,2-2V6c0-1.1046-.8954-2-2-2ZM6,26V6h20v20H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SquareOutline.propTypes = iconPropTypes;
}
const SquareSolid = /*#__PURE__*/React.forwardRef(function SquareSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 32V0h32v32z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SquareSolid.propTypes = iconPropTypes;
}
const SquareFill = /*#__PURE__*/React.forwardRef(function SquareFill({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
      d: "M3 3H13V13H3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H13V13H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SquareFill.propTypes = iconPropTypes;
}
const StackLimitation = /*#__PURE__*/React.forwardRef(function StackLimitation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H16V30H8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24,12H20v2h4v2H21v2h3v2H20v2h4a2.0027,2.0027,0,0,0,2-2V14A2.0023,2.0023,0,0,0,24,12Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20H8V12h8Zm-6-2h4V14H10Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.41L14.59 2 12 4.59 9.41 2 8 3.41 10.59 6 8 8.59 9.41 10 12 7.41 14.59 10 16 8.59 13.41 6 16 3.41z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StackLimitation.propTypes = iconPropTypes;
}
const WatsonHealthStackedMove = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedMove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H15a2,2,0,0,1,2,2V26A2,2,0,0,1,15,28ZM4,11V26H15V11Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6,24.59,7.41,27,10H22V6a2,2,0,0,0-2-2H10V6H20V20h2V12h5l-2.41,2.59L26,16l5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStackedMove.propTypes = iconPropTypes;
}
const WatsonHealthStackedScrolling_1 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H18a2,2,0,0,1,2,2V28A2,2,0,0,1,18,30ZM4,14V28H18V14Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H23V9H9V7H23a2,2,0,0,1,2,2Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28V4H16V2H28a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStackedScrolling_1.propTypes = iconPropTypes;
}
const WatsonHealthStackedScrolling_2 = /*#__PURE__*/React.forwardRef(function WatsonHealthStackedScrolling_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H2a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2V28A2,2,0,0,1,8,30ZM2,14V28H8V14Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H14a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,20,30ZM14,14V28h6V14Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V9H17V7h8a2,2,0,0,1,2,2Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M32,16H30V4H22V2h8a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStackedScrolling_2.propTypes = iconPropTypes;
}
const Stamp = /*#__PURE__*/React.forwardRef(function Stamp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H20V14.8982a7.4938,7.4938,0,0,1,1.1587-3.8542,5.9751,5.9751,0,0,0-1.3735-7.7006,5.9968,5.9968,0,0,0-9.6829,3.54,5.91,5.91,0,0,0,.7478,4.175A7.2573,7.2573,0,0,1,12,14.7942V18H6a2.002,2.002,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2v2a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V26a2.0025,2.0025,0,0,0,2-2V20A2.002,2.002,0,0,0,26,18ZM12.07,7.244a3.9994,3.9994,0,1,1,7.3728,2.7731A9.76,9.76,0,0,0,18.0664,14H13.94a9.5433,9.5433,0,0,0-1.376-3.9736A3.9366,3.9366,0,0,1,12.07,7.244ZM18,16v2H14V16Zm6,12H8V26H24ZM6,24V20H26v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Stamp.propTypes = iconPropTypes;
}
const Star = /*#__PURE__*/React.forwardRef(function Star({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
      d: "M8,3.3l1.4,2.8l0.2,0.5l0.5,0.1l3.1,0.4L11,9.2l-0.4,0.4l0.1,0.5l0.5,3.1l-2.8-1.4L8,11.5l-0.5,0.2l-2.8,1.4l0.5-3.1 l0.1-0.5L5,9.2L2.8,7l3.1-0.4l0.5-0.1L6.6,6L8,3.3 M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7 L8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Star.propTypes = iconPropTypes;
}
const StarFilled = /*#__PURE__*/React.forwardRef(function StarFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1L5.7,5.6L0.6,6.3l3.7,3.6L3.5,15L8,12.6l4.6,2.4l-0.9-5.1l3.7-3.6l-5.1-0.7L8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StarFilled.propTypes = iconPropTypes;
}
const StarHalf = /*#__PURE__*/React.forwardRef(function StarHalf({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
      d: "M5.7 5.6L0.6 6.3 4.3 9.9 3.5 15 8 12.6 8 1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 11.22L1.28 12.7 8.64 19.87 6.9 30 16 25.22 16 2 11.45 11.22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StarHalf.propTypes = iconPropTypes;
}
const StarReview = /*#__PURE__*/React.forwardRef(function StarReview({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H26V28H18z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H30V24H18z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H30V20H18z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M20.549 11.217L16 2 11.451 11.217 1.28 12.695 8.64 19.87 6.902 30 14 26.269 14 24.009 9.559 26.344 10.611 20.208 10.789 19.171 10.036 18.438 5.578 14.091 11.739 13.196 12.779 13.045 13.245 12.102 16 6.519 18.755 12.102 19.221 13.045 20.261 13.196 27.715 14.281 28 12.3 20.549 11.217z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StarReview.propTypes = iconPropTypes;
}
const WatsonHealthStatusAcknowledge = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusAcknowledge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStatusAcknowledge.propTypes = iconPropTypes;
}
const WatsonHealthStatusChange = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusChange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M7,30a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,23,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,22Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M24,7v7l3.5859-3.4141L29,12l-6,6-6-6,1.4141-1.4141L22,14V7a1.0009,1.0009,0,0,0-1-1H9A1.0006,1.0006,0,0,0,8,7V18H6V7A3.0033,3.0033,0,0,1,9,4H21A3.0033,3.0033,0,0,1,24,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStatusChange.propTypes = iconPropTypes;
}
const WatsonHealthStatusPartialFail = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusPartialFail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1407,23.7642l1.5315,1.2851a13.976,13.976,0,0,0,2.4408-4.1821l-1.8776-.6836A11.9729,11.9729,0,0,1,25.1407,23.7642Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18,27.81l.4128,1.9677A13.8888,13.8888,0,0,0,22.9543,28.14L22,26.4087A12.52,12.52,0,0,1,18,27.81Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M10,26.4087,9,28.14a14.14,14.14,0,0,0,4.5872,1.6382l.3469-1.9677A12.1519,12.1519,0,0,1,10,26.4087Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7646,20.1836l-1.8776.6836a13.976,13.976,0,0,0,2.4408,4.1821l1.5315-1.2851A11.9729,11.9729,0,0,1,4.7646,20.1836Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,22Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V19H15z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12,12,0,0,0,4,16H2a14,14,0,0,1,28,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStatusPartialFail.propTypes = iconPropTypes;
}
const WatsonHealthStatusResolved = /*#__PURE__*/React.forwardRef(function WatsonHealthStatusResolved({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.414L16 23.413 17.413 22 21 25.586 28.585 18 30 19.415 21 28.414z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8193,25.8022a11.992,11.992,0,1,1,13.9829-9.6215l-1.9668-.3614A10.001,10.001,0,1,0,12.1807,23.835Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStatusResolved.propTypes = iconPropTypes;
}
const StayInside = /*#__PURE__*/React.forwardRef(function StayInside({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30H21V28a3.0033,3.0033,0,0,0-3-3H14a3.0033,3.0033,0,0,0-3,3v2H9V28a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,16,11Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V14.4639L16,4.31,4,14.4639V30H2V14a1,1,0,0,1,.354-.7634l13-11a1,1,0,0,1,1.292,0l13,11A1,1,0,0,1,30,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StayInside.propTypes = iconPropTypes;
}
const StemLeafPlot = /*#__PURE__*/React.forwardRef(function StemLeafPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M19,10a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,19,10Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,19,6Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M19,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,19,19Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,19,15Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,27,19Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,27,15Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M19,28a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,19,28Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,19,24Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H14V30H12z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,28Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,7,24Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Zm0-4a1,1,0,1,0,1,1A1.0011,1.0011,0,0,0,7,15Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7,10a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,10ZM7,6A1,1,0,1,0,8,7,1.0011,1.0011,0,0,0,7,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StemLeafPlot.propTypes = iconPropTypes;
}
const Stethoscope = /*#__PURE__*/React.forwardRef(function Stethoscope({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2V4h2v6a4,4,0,0,1-8,0V4h2V2H16v8a6.0051,6.0051,0,0,0,5,5.91V22A6,6,0,0,1,9,22V15.8579a4,4,0,1,0-2,0V22a8,8,0,0,0,16,0V15.91A6.0051,6.0051,0,0,0,28,10V2ZM6,12a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,6,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Stethoscope.propTypes = iconPropTypes;
}
const Stickies = /*#__PURE__*/React.forwardRef(function Stickies({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22v-12c0-1.1-.9-2-2-2H12c-1.1,0-2,.9-2,2v18c0,1.1.9,2,2,2h10c.3,0,.5-.1.7-.3l7-7c.2-.2.3-.4.3-.7ZM22,22h5.6s-5.6,5.6-5.6,5.6v-5.6ZM28,20h-6c-1.1,0-2,.9-2,2v6h-8V10h16v10Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M4,22V4h16v2h2v-2c0-1.1001-.8999-2-2-2H4c-1.1001,0-2,.8999-2,2v18c0,1.1001.8999,2,2,2h4v-2H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Stickies.propTypes = iconPropTypes;
}
const Stop = /*#__PURE__*/React.forwardRef(function Stop({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
      d: "M12,4v8H4V4H12 M12,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8V24H8V8H24m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Stop.propTypes = iconPropTypes;
}
const StopFilled = /*#__PURE__*/React.forwardRef(function StopFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4 c0.6,0,1,0.4,1,1V10z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopFilled.propTypes = iconPropTypes;
}
const StopFilledAlt = /*#__PURE__*/React.forwardRef(function StopFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24,6H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopFilledAlt.propTypes = iconPropTypes;
}
const StopOutline = /*#__PURE__*/React.forwardRef(function StopOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
      d: "M10,6v4H6V6H10 M10,5H6C5.4,5,5,5.4,5,6v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V6C11,5.4,10.6,5,10,5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12v8H12V12h8m0-2H12a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopOutline.propTypes = iconPropTypes;
}
const StopOutlineFilled = /*#__PURE__*/React.forwardRef(function StopOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11,10c0,0.6-0.4,1-1,1H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h4 c0.6,0,1,0.4,1,1V10z"
    })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
      d: "M6 6H10V10H6z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6,18a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V20H12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopOutlineFilled.propTypes = iconPropTypes;
}
const StopSign = /*#__PURE__*/React.forwardRef(function StopSign({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29ZM11.4141,5,5,11.4141v9.1716L11.4141,27h9.1716L27,20.5859V11.4143L20.5859,5H11.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopSign.propTypes = iconPropTypes;
}
const StopSignFilled = /*#__PURE__*/React.forwardRef(function StopSignFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5857,29H11.4143A1.9865,1.9865,0,0,1,10,28.4141L3.5859,22A1.9865,1.9865,0,0,1,3,20.5857V11.4143A1.9865,1.9865,0,0,1,3.5859,10L10,3.5859A1.9865,1.9865,0,0,1,11.4143,3h9.1714A1.9865,1.9865,0,0,1,22,3.5859L28.4141,10A1.9865,1.9865,0,0,1,29,11.4143v9.1714A1.9865,1.9865,0,0,1,28.4141,22L22,28.4141A1.9865,1.9865,0,0,1,20.5857,29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StopSignFilled.propTypes = iconPropTypes;
}
const StoragePool = /*#__PURE__*/React.forwardRef(function StoragePool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,13A3.5,3.5,0,1,1,21,9.5,3.5041,3.5041,0,0,1,17.5,13Zm0-5A1.5,1.5,0,1,0,19,9.5,1.5017,1.5017,0,0,0,17.5,8Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,26A3.5,3.5,0,1,1,18,22.5,3.5041,3.5041,0,0,1,14.5,26Zm0-5A1.5,1.5,0,1,0,16,22.5,1.5017,1.5017,0,0,0,14.5,21Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,18A3.5,3.5,0,1,1,13,14.5,3.5041,3.5041,0,0,1,9.5,18Zm0-5A1.5,1.5,0,1,0,11,14.5,1.5017,1.5017,0,0,0,9.5,13Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,21A3.5,3.5,0,1,1,26,17.5,3.5041,3.5041,0,0,1,22.5,21Zm0-5A1.5,1.5,0,1,0,24,17.5,1.5017,1.5017,0,0,0,22.5,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StoragePool.propTypes = iconPropTypes;
}
const StorageRequest = /*#__PURE__*/React.forwardRef(function StorageRequest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M4,21H2v3a2.0059,2.0059,0,0,0,2,2H7V24H4Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M4,8H7V6H4A2.0059,2.0059,0,0,0,2,8v3H4Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6H23V8H17z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H15V8H9z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H23V26H17z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15L4 15 4 13 2 13 2 19 4 19 4 17 28 17 28 19 30 19 30 13 28 13 28 15z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H25v2h3a2.0059,2.0059,0,0,0,2-2V21H28Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H25V8h3v3h2V8A2.0059,2.0059,0,0,0,28,6Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24H15V26H9z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "12",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StorageRequest.propTypes = iconPropTypes;
}
const Store = /*#__PURE__*/React.forwardRef(function Store({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Store.propTypes = iconPropTypes;
}
const StormTracker = /*#__PURE__*/React.forwardRef(function StormTracker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a1,1,0,0,0-.9736.771l-1.7229,7.3223a10.0653,10.0653,0,1,0,8.6032,8.603l7.3223-1.7227A1,1,0,0,0,30,16,14.0158,14.0158,0,0,0,16,2ZM11.293,20.707A1,1,0,0,0,12,21a1.013,1.013,0,0,0,.229-.0264l3.7622-.8852a3.996,3.996,0,1,1-4.08-4.08l-.8852,3.7622A1,1,0,0,0,11.293,20.707Zm2.05-2.0508,2.271-9.65a7.5018,7.5018,0,0,1,7.38,7.38ZM20,20a8,8,0,1,1-8-8,8.1017,8.1017,0,0,1,.8438.0469L12.38,14.019C12.2532,14.0107,12.127,14,12,14a6,6,0,1,0,6,6c0-.127-.011-.2534-.019-.38l1.9721-.4643A8.1048,8.1048,0,0,1,20,20Zm4.9707-4.0791a9.4981,9.4981,0,0,0-8.8914-8.8916l.7068-3.0039A12.0193,12.0193,0,0,1,27.9746,15.2139Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StormTracker.propTypes = iconPropTypes;
}
const StrategyPlay = /*#__PURE__*/React.forwardRef(function StrategyPlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M12 3.415L10.586 2 7 5.587 3.414 2 2 3.415 5.586 7 2 10.586 3.414 12 7 8.414 10.586 12 12 10.586 8.414 7 12 3.415z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m25,2l-5,5,1.4089,1.4189,2.5911-2.625v9.2061H8c-1.1028,0-2,.8975-2,2v3.1011c-2.2793.4644-4,2.4844-4,4.8989,0,2.7568,2.2429,5,5,5s5-2.2432,5-5c0-2.4146-1.7207-4.4346-4-4.8989v-3.1011h16c1.1028,0,2-.8975,2-2V5.8472l2.5911,2.5718,1.4089-1.4189-5-5Zm-15,23c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3,1.3457-3,3-3,3,1.3457,3,3Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M30 21.415L28.586 20 25 23.587 21.414 20 20 21.415 23.586 25 20 28.586 21.414 30 25 26.414 28.586 30 30 28.586 26.414 25 30 21.415z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StrategyPlay.propTypes = iconPropTypes;
}
const Strawberry = /*#__PURE__*/React.forwardRef(function Strawberry({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V12H9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H11V16H9z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H15V14H13z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M9,28a5.169,5.169,0,0,1-.7441-.054A5.0935,5.0935,0,0,1,4,22.8669V11.1985a7.1615,7.1615,0,0,1,6.31-7.1653,6.9607,6.9607,0,0,1,4.4643,1.0706l7.9688,4.9807a6.98,6.98,0,0,1-.6885,12.19l-10.88,5.2285A4.9765,4.9765,0,0,1,9,28ZM11.002,6q-.2484,0-.5005.0241A5.1463,5.1463,0,0,0,6,11.1985V22.8669a3.0839,3.0839,0,0,0,2.5435,3.1,3.0266,3.0266,0,0,0,1.7622-.2649l10.8828-5.23a4.9807,4.9807,0,0,0,.4887-8.6958L13.7046,6.7935A4.9687,4.9687,0,0,0,11.002,6Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7H22a4.0045,4.0045,0,0,1-4-4V2h2V3a2.0021,2.0021,0,0,0,2,2h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Strawberry.propTypes = iconPropTypes;
}
const WatsonHealthStressBreathEditor = /*#__PURE__*/React.forwardRef(function WatsonHealthStressBreathEditor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M20,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,20,2Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V25a5,5,0,0,0-5-5H17a5,5,0,0,0-5,5v5H10V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M11,8H5A3,3,0,0,1,2,5V3H4V5A1,1,0,0,0,5,6h6Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M4,15H2V13a3,3,0,0,1,3-3h6v2H5a1,1,0,0,0-1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStressBreathEditor.propTypes = iconPropTypes;
}
const StringInteger = /*#__PURE__*/React.forwardRef(function StringInteger({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12H22v2h4v2H23v2h3v2H22v2h4a2.0027,2.0027,0,0,0,2-2V14A2.0023,2.0023,0,0,0,26,12Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M19,22H13V18a2.002,2.002,0,0,1,2-2h2V14H13V12h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H15v2h4Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20L8 12 6 12 6 13 4 13 4 15 6 15 6 20 4 20 4 22 10 22 10 20 8 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StringInteger.propTypes = iconPropTypes;
}
const StringText = /*#__PURE__*/React.forwardRef(function StringText({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M29,22H24a2.0027,2.0027,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2h5v2H24v6h5Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M18,12H14V8H12V22h6a2.0027,2.0027,0,0,0,2-2V14A2.0023,2.0023,0,0,0,18,12Zm-4,8V14h4v6Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M8,12H3v2H8v2H4a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V14A2.0023,2.0023,0,0,0,8,12Zm0,8H4V18H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  StringText.propTypes = iconPropTypes;
}
const WatsonHealthStudyNext = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyNext({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M23.93 21L30 15 23.93 9 22.5 10.41 27.14 15 22.5 19.59 23.93 21z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyNext.propTypes = iconPropTypes;
}
const WatsonHealthStudyPrevious = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyPrevious({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 21L2 15 8.07 9 9.5 10.41 4.86 15 9.5 19.59 8.07 21z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M20,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,20,2Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V25a5,5,0,0,0-5-5H17a5,5,0,0,0-5,5v5H10V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyPrevious.propTypes = iconPropTypes;
}
const WatsonHealthStudyRead = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyRead({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.414L16 24.413 17.413 23 21 26.586 28.585 19 30 20.415 21 29.414z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 15 22 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M13,24H4V4H24V16h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2h9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyRead.propTypes = iconPropTypes;
}
const WatsonHealthStudySkip = /*#__PURE__*/React.forwardRef(function WatsonHealthStudySkip({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9h5.2A11,11,0,0,0,7,15H5A13,13,0,0,1,28,6.7V3h2v8H22Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a3,3,0,1,1-3,3,2.95,2.95,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,16,10Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30H21V27a3,3,0,0,0-3-3H14a3,3,0,0,0-3,3v3H9V27a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudySkip.propTypes = iconPropTypes;
}
const WatsonHealthStudyTransfer = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyTransfer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 19.414L13.165 24 8.586 28.586 10 30 16 24 10 18 8.586 19.414z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 19.414L7.165 24 2.586 28.586 4 30 10 24 4 18 2.586 19.414z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14L12 12 17 12 17 10 14 10 14 8 17 8 17 6 19 6 19 8 22 8 22 10 19 10 19 12 24 12 24 14 19 14 19 16 24 16 24 18 19 18 19 20 22 20 22 22 17 22 17 18 14 18 14 16 17 16 17 14 12 14z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24h9V4H8V16H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V24a2,2,0,0,1-2,2H19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyTransfer.propTypes = iconPropTypes;
}
const WatsonHealthStudyUnread = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyUnread({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14L20 12 15 12 15 10 18 10 18 8 15 8 15 6 13 6 13 8 10 8 10 10 13 10 13 12 8 12 8 14 13 14 13 16 8 16 8 18 13 18 13 20 10 20 10 22 17 22 17 20 15 20 15 18 18 18 18 16 15 16 15 14 20 14z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M15,24H4V4H24V15h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyUnread.propTypes = iconPropTypes;
}
const WatsonHealthStudyView = /*#__PURE__*/React.forwardRef(function WatsonHealthStudyView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H25V18h3V4H14V7H12V4a2.002,2.002,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L17 20 13 20 13 18 16 18 16 16 13 16 13 14 11 14 11 16 8 16 8 18 11 18 11 20 7 20 7 22 11 22 11 24 8 24 8 26 16 26 16 24 13 24 13 22 17 22z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H20a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,20,30ZM4,12V28H20V12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthStudyView.propTypes = iconPropTypes;
}
const WatsonHealthSubVolume = /*#__PURE__*/React.forwardRef(function WatsonHealthSubVolume({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4741,19.12,23.6807,16l5.7934-3.12a1,1,0,0,0,0-1.7607l-13-7a.9982.9982,0,0,0-.9482,0l-13,7a1,1,0,0,0,0,1.7607L8.3193,16,2.5259,19.12a1,1,0,0,0,0,1.7607l13,7a.9995.9995,0,0,0,.9482,0l13-7a1,1,0,0,0,0-1.7607ZM16,6.1359,26.8906,12,16,17.8643,5.1094,12Zm0,19.7284L5.1094,20l5.3193-2.8642L15.5259,19.88a.9995.9995,0,0,0,.9482,0l5.0972-2.7446L26.8906,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSubVolume.propTypes = iconPropTypes;
}
const Subclassification = /*#__PURE__*/React.forwardRef(function Subclassification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,28v-10h7c.3564,0,.686-.1899.8647-.498.0902-.1551.1353-.3285.1353-.502,0-.1711-.0441-.3424-.1318-.4961L12.8682,2.504c-.1919-.3359-.5301-.504-.8682-.504s-.6763.1681-.8682.504l-7.9999,13.9999c-.0878.1537-.1318.3249-.1318.4961,0,.1735.0451.3469.1353.502.1787.3081.5083.498.8647.498h7v10c0,1.1046.8954,2,2,2h15v-2h-15Zm-7.2769-12l6.2769-10.9844,6.2769,10.9844H5.7231Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subclassification.propTypes = iconPropTypes;
}
const Subdirectory = /*#__PURE__*/React.forwardRef(function Subdirectory({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m9,20l1.4141,1.4141-2.5859,2.5859h18.1719s0-20,0-20h2v20c0,1.1025-.897,2-2,2H7.8281s2.5859,2.5859,2.5859,2.5859l-1.4141,1.4141-5-5,5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subdirectory.propTypes = iconPropTypes;
}
const Subflow = /*#__PURE__*/React.forwardRef(function Subflow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12.0025,12.0025,0,0,0,22.4609,26.1143l1.0782,1.684A13.9511,13.9511,0,0,1,16,30Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16H28A12.0025,12.0025,0,0,0,9.5391,5.8857L8.4609,4.2017A14.0019,14.0019,0,0,1,30,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subflow.propTypes = iconPropTypes;
}
const SubflowLocal = /*#__PURE__*/React.forwardRef(function SubflowLocal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3472,29.9851a13.9282,13.9282,0,0,1-4.2051-.8516l.6943-1.8754a11.929,11.929,0,0,0,3.6026.729Zm4.2651-.4558-.5146-1.9326a11.915,11.915,0,0,0,3.3632-1.4827l1.0782,1.6846A13.915,13.915,0,0,1,19.6123,29.5293ZM7.395,27.0439a14.0632,14.0632,0,0,1-2.94-3.1218l1.6484-1.1333a12.0521,12.0521,0,0,0,2.522,2.6785ZM2.5967,20.0544A14.0512,14.0512,0,0,1,2.0005,16H4a12.0412,12.0412,0,0,0,.5117,3.4763Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17l-1.4141,1.4141L26.1719,20H15.8157a2.9874,2.9874,0,0,0-.2742-.5762l4.481-5.601A2.9676,2.9676,0,0,0,21,14a3,3,0,1,0-2.8157-4H13.8157a2.982,2.982,0,0,0-5.6314,0H2v2H8.1843a2.982,2.982,0,0,0,5.6314,0h4.3686a2.9874,2.9874,0,0,0,.2742.5762l-4.481,5.601A2.9676,2.9676,0,0,0,13,18a3,3,0,1,0,2.8157,4H26.1719l-1.586,1.5859L26,25l4-4Zm-5-7a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,10ZM11,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,12Zm2,10a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,13,22Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16a12.0412,12.0412,0,0,0-.5117-3.4763l1.915-.5781A14.0551,14.0551,0,0,1,30,16ZM25.8965,9.2112a12.0521,12.0521,0,0,0-2.522-2.6785l1.23-1.5766a14.0632,14.0632,0,0,1,2.94,3.1218ZM9.5391,5.886,8.4609,4.2014a13.915,13.915,0,0,1,3.9268-1.7307l.5146,1.9326A11.915,11.915,0,0,0,9.5391,5.886ZM20.1636,4.7419a11.929,11.929,0,0,0-3.6026-.729l.0918-1.998a13.9282,13.9282,0,0,1,4.2051.8516Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubflowLocal.propTypes = iconPropTypes;
}
const SubjectDefinition = /*#__PURE__*/React.forwardRef(function SubjectDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22.7749,20.5022h-.0862c-.3101.8959-1.0334,1.7056-2.5151,1.7056-1.8433,0-2.877-1.2749-2.877-3.5144v-5.6849h2.2051v5.4609c0,1.2404.4651,1.9122,1.5161,1.9122.8784,0,1.7571-.4651,1.7571-1.4298v-5.9434h2.2051v8.9926h-2.2051v-1.4988Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m6.6195,20.2094l1.5332-1.4816c.8269.9647,1.8433,1.4816,3.0837,1.4816,1.3953,0,2.1189-.6719,2.1189-1.6882,0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971,0-2.1534,1.6709-3.5488,4.3584-3.5488,1.8088,0,3.1526.6202,4.1172,1.7744l-1.5503,1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292,0-1.9639.5168-1.9639,1.4126,0,.9131.5168,1.292,1.6711,1.4988l1.1196.2067c2.429.4308,3.5662,1.516,3.5662,3.4972,0,2.2739-1.6367,3.8245-4.5137,3.8245-2.05,0-3.4626-.8097-4.479-1.9984Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubjectDefinition.propTypes = iconPropTypes;
}
const SubjectUsage = /*#__PURE__*/React.forwardRef(function SubjectUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22.7749,20.5022h-.0862c-.3101.8959-1.0334,1.7056-2.5151,1.7056-1.8433,0-2.877-1.2749-2.877-3.5144v-5.6849h2.2051v5.4609c0,1.2404.4651,1.9122,1.5161,1.9122.8784,0,1.7571-.4651,1.7571-1.4298v-5.9434h2.2051v8.9926h-2.2051v-1.4988Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m6.6195,20.2094l1.5332-1.4816c.8269.9647,1.8433,1.4816,3.0837,1.4816,1.3953,0,2.1189-.6719,2.1189-1.6882,0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971,0-2.1534,1.6709-3.5488,4.3584-3.5488,1.8088,0,3.1526.6202,4.1172,1.7744l-1.5503,1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292,0-1.9639.5168-1.9639,1.4126,0,.9131.5168,1.292,1.6711,1.4988l1.1196.2067c2.429.4308,3.5662,1.516,3.5662,3.4972,0,2.2739-1.6367,3.8245-4.5137,3.8245-2.05,0-3.4626-.8097-4.479-1.9984Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubjectUsage.propTypes = iconPropTypes;
}
const SubnetAclRules = /*#__PURE__*/React.forwardRef(function SubnetAclRules({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H30V16H18z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H26V21H18z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H30V11H18z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24v4H6V16h8V14H10V8a4.0008,4.0008,0,0,1,7.6675-1.6L19.5005,5.6A6.001,6.001,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubnetAclRules.propTypes = iconPropTypes;
}
const Subsetting = /*#__PURE__*/React.forwardRef(function Subsetting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8682,16.5039L16.8682,2.5039c-.356-.623-1.3804-.623-1.7363,0l-8,14c-.177.3096-.1758.6895.0032.998.179.3081.5085.498.865.498h7v12h2v-12h7c.3564,0,.686-.1899.865-.498.179-.3086.1802-.6885.0032-.998ZM9.7231,16l6.2769-10.9844,6.2769,10.9844h-12.5537Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subsetting.propTypes = iconPropTypes;
}
const Subtract = /*#__PURE__*/React.forwardRef(function Subtract({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Subtract.propTypes = iconPropTypes;
}
const SubtractAlt = /*#__PURE__*/React.forwardRef(function SubtractAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14 S23.7,2,16,2z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H24V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubtractAlt.propTypes = iconPropTypes;
}
const SubtractFilled = /*#__PURE__*/React.forwardRef(function SubtractFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-7.6,0-14,6.4-14,14s6.4,14,14,14,14-6.4,14-14S23.6,2,16,2Zm8,15H8v-2h16v2Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 17L8 17 8 15 24 15 24 17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubtractFilled.propTypes = iconPropTypes;
}
const SubtractLarge = /*#__PURE__*/React.forwardRef(function SubtractLarge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15L5 17 27 17 27 15 5 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SubtractLarge.propTypes = iconPropTypes;
}
const Succession = /*#__PURE__*/React.forwardRef(function Succession({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M19 27H21V31H19z",
    transform: "rotate(90 20 29)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M25 27H27V31H25z",
    transform: "rotate(90 26 29)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,28v-3h-2v3c0,1.1046.8954,2,2,2h3v-2h-3Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M11 19H13V23H11z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M11 13H13V17H11z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M22 12L12 2 2 12 3.4141 13.4141 11 5.8281 11 11 13 11 13 5.8281 20.5859 13.4141 22 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Succession.propTypes = iconPropTypes;
}
const SuccessionFlowConnection = /*#__PURE__*/React.forwardRef(function SuccessionFlowConnection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M7,3v2s-5,0-5,0v-2s5,0,5,0ZM13,16h2s0-5,0-5h-2s0,5,0,5ZM15,5c0-1.1028-.8972-2-2-2h-4v2h4v4h2v-4ZM19,22h-4v-4h-2v4c0,1.1028.8972,2,2,2h4v-2ZM30.6001,22.2002l-8-6c-.303-.2275-.7083-.2642-1.0474-.0947-.3386.1694-.5527.5156-.5527.8945v12c0,.3789.2141.7251.5527.8945.1416.0708.2947.1055.447.1055.2126,0,.4238-.0674.6003-.2002l8-6c.2517-.1885.3999-.4849.3999-.7998s-.1482-.6113-.3999-.7998Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SuccessionFlowConnection.propTypes = iconPropTypes;
}
const SummaryKpi = /*#__PURE__*/React.forwardRef(function SummaryKpi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6667,27.5027,2,22.4484l1.3311-1.4927,5.6411,5.0316,7.6906-7.4449a1.9282,1.9282,0,0,1,2.6736-.0084L22.96,21.9983l5.5791-5.9735L30,17.3905l-5.5812,5.9758a1.996,1.996,0,0,1-2.8379.08l-3.5765-3.4191-7.666,7.4206A1.9629,1.9629,0,0,1,7.6667,27.5027Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L26 11 28 8 30 11z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4H18V6h4V8H19v2h3v2H18v2h4a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14H10V10a2.002,2.002,0,0,1,2-2h2V6H10V4h4a2.0023,2.0023,0,0,1,2,2V8a2.0023,2.0023,0,0,1-2,2H12v2h4Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L6 4 4 4 4 5 2 5 2 7 4 7 4 12 2 12 2 14 8 14 8 12 6 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SummaryKpi.propTypes = iconPropTypes;
}
const SummaryKpiMirror = /*#__PURE__*/React.forwardRef(function SummaryKpiMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3,27.5l5.7-5.1L28.7,21L23,26l-7.7-7.4c-0.7-0.7-1.9-0.7-2.7,0L9,22l-5.6-6L2,17.4l5.6,6c0.8,0.8,2,0.8,2.8,0.1L14,20 l7.7,7.4C22.4,28.2,23.6,28.2,24.3,27.5z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12L28 4 26 4 26 5 24 5 24 7 26 7 26 12 24 12 24 14 30 14 30 12z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14h-6v-4c0-1.1,0.9-2,2-2h2V6h-4V4h4c1.1,0,2,0.9,2,2v2c0,1.1-0.9,2-2,2h-2v2h4V14z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4H8v2h4v2H9v2h3v2H8v2h4c1.1,0,2-0.9,2-2V6C14,4.9,13.1,4,12,4z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11L2 11 4 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SummaryKpiMirror.propTypes = iconPropTypes;
}
const Sun = /*#__PURE__*/React.forwardRef(function Sun({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 .005)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.86 7.856)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.005H7V17.005000000000003H2z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.86 24.149)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.005H17V30.005H15z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.152 24.149)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.005H30V17.005000000000003H25z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.152 7.856)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.005H17V7.005H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sun.propTypes = iconPropTypes;
}
const Sunrise = /*#__PURE__*/React.forwardRef(function Sunrise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27H29.998V29H2z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22H30V24H25z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.146 15.854)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.854 15.854)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H7V24H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sunrise.propTypes = iconPropTypes;
}
const Sunset = /*#__PURE__*/React.forwardRef(function Sunset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27.005H29.998V29.005H2z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
    transform: "translate(0 .005)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.005H30V24.005H25z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
    transform: "rotate(-45 24.152 15.856)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 13.374H8.854V18.332H6.854z",
    transform: "rotate(-45 7.86 15.856)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22.005H7V24.005H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sunset.propTypes = iconPropTypes;
}
const SupportVectorMachine = /*#__PURE__*/React.forwardRef(function SupportVectorMachine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "18",
    r: "4"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.799 15H34.799V17H-2.799z",
    transform: "rotate(-45 16 16)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "m14,10c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Zm0-6c-1.1028,0-2,.8972-2,2s.8972,2,2,2,2-.8972,2-2-.8972-2-2-2Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m6,18c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Zm0-6c-1.1028,0-2,.8972-2,2s.8972,2,2,2,2-.8972,2-2-.8972-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SupportVectorMachine.propTypes = iconPropTypes;
}
const Sustainability = /*#__PURE__*/React.forwardRef(function Sustainability({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5708,27.7495c-1.7468.8296-3.6211,1.2505-5.5708,1.2505-7.1682,0-13-5.832-13-13,0-3.0752,1.0571-5.979,3-8.3076v2.3076h2v-6H2v2h2.8416c-2.4753,2.7539-3.8416,6.2622-3.8416,10,0,8.271,6.729,15,15,15,2.249,0,4.4119-.4858,6.4292-1.4438l-.8584-1.8066Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "m21,9c-3.1602,0-5.7515,2.457-5.9778,5.5605-1.0654-.9658-2.4739-1.5605-4.0222-1.5605h-4v4c0,3.3086,2.6917,6,6,6h2v4h2v-8.0005l2,.0005c3.3083,0,6-2.6914,6-6v-4h-4Zm-8,12c-2.2056,0-4-1.7944-4-4v-2h2c2.2056,0,4,1.7944,4,4v.5859l-2.293-2.293-1.4141,1.4141,2.293,2.293h-.5859Zm10-8c0,2.2056-1.7944,4-4,4h-.5859l2.293-2.293-1.4141-1.4141-2.293,2.293v-.5859c0-2.2056,1.7944-4,4-4h2v2Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "m31,16c0-8.271-6.729-15-15-15-2.249,0-4.4119.4858-6.4292,1.4438l.8584,1.8066c1.7468-.8296,3.6211-1.2505,5.5708-1.2505,7.1682,0,13,5.832,13,13,0,3.0752-1.0571,5.979-3,8.3076v-2.3076h-2v6h6v-2h-2.8416c2.4753-2.7539,3.8416-6.2622,3.8416-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sustainability.propTypes = iconPropTypes;
}
const Svg = /*#__PURE__*/React.forwardRef(function Svg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H24V21h4V17H26V15h4Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M8,23H2V21H8V17H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9h6v2H4v4H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Svg.propTypes = iconPropTypes;
}
const Swim = /*#__PURE__*/React.forwardRef(function Swim({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M30,26H28a4.9316,4.9316,0,0,1-4-1.9873,5.0192,5.0192,0,0,1-8,0,5.0192,5.0192,0,0,1-8,0A4.9316,4.9316,0,0,1,4,26H2V24H4a3.44,3.44,0,0,0,3.0532-2.3215A.9712.9712,0,0,1,8,21a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,12,24a3.44,3.44,0,0,0,3.0532-2.3215A.99.99,0,0,1,16,21a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,20,24a3.44,3.44,0,0,0,3.0532-2.3215,1,1,0,0,1,1.8955.0053A3.4381,3.4381,0,0,0,28,24h2Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5859l-8.707-8.707A2.9791,2.9791,0,0,0,12.1714,8H4v2h8.1714a.9933.9933,0,0,1,.7075.293L15.5859,13,10,18.5859,11.4141,20,17,14.4141,21.5859,19Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,20,10Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,22,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Swim.propTypes = iconPropTypes;
}
const SwimlaneDVertical = /*#__PURE__*/React.forwardRef(function SwimlaneDVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M25,26h2v4h-4v-2h2v-2ZM17,30h4v-2h-4v2ZM7,26h-2v4h4v-2h-2v-2ZM7,19.9995h-2v4.0005h2v-4.0005ZM7,14h-2v4h2v-4ZM5,8v3.9995h2v-1.9995h2v-2h-4ZM5,6h2v-2h2v-2h-4v4ZM17,4h4v-2h-4v2ZM11,4h4v-2h-4v2ZM23,2v2h2v2h2V2h-4ZM25,24h2v-3.9995h-2v3.9995ZM25,18h2v-4h-2v4ZM17,10h4v-2h-4v2ZM11,10h4v-2h-4v2ZM23,8v2h2v2h2v-4h-4ZM11,30h4v-2h-4v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SwimlaneDVertical.propTypes = iconPropTypes;
}
const SwitchLayer_2 = /*#__PURE__*/React.forwardRef(function SwitchLayer_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26L16 24 5.83 24 8.41 21.41 7 20 2 25 7 30 8.41 28.59 5.83 26 16 26z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14L16 12 5.83 12 8.41 9.41 7 8 2 13 7 18 8.41 16.59 5.83 14 16 14z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6L16 8 26.17 8 23.59 10.59 25 12 30 7 25 2 23.59 3.41 26.17 6 16 6z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18L16 20 26.17 20 23.59 22.59 25 24 30 19 25 14 23.59 15.41 26.17 18 16 18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SwitchLayer_2.propTypes = iconPropTypes;
}
const SwitchLayer_3 = /*#__PURE__*/React.forwardRef(function SwitchLayer_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6 24.586 6 19.586 11 21 12.414 26 7.414 26 10 28 10 28 4 22 4z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4L10 6 7.414 6 12.414 11 11 12.414 6 7.414 6 10 4 10 4 4 10 4z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5L16 1 12 5 13.414 6.414 15 4.829 15 11 17 11 17 4.829 18.586 6.414 20 5z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28L22 26 24.586 26 19.586 21 21 19.586 26 24.586 26 22 28 22 28 28 22 28z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28L10 26 7.414 26 12.414 21 11 19.586 6 24.586 6 22 4 22 4 28 10 28z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27L16 31 12 27 13.414 25.586 15 27.171 15 21 17 21 17 27.171 18.586 25.586 20 27z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12L1 16 5 20 6.414 18.586 4.829 17 11 17 11 15 4.829 15 6.414 13.414 5 12z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12L31 16 27 20 25.586 18.586 27.171 17 21 17 21 15 27.171 15 25.586 13.414 27 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SwitchLayer_3.propTypes = iconPropTypes;
}
const Switcher = /*#__PURE__*/React.forwardRef(function Switcher({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H18V8H14z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H8V8H4z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H28V8H24z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H18V18H14z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14H8V18H4z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H28V18H24z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H18V28H14z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H8V28H4z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H28V28H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Switcher.propTypes = iconPropTypes;
}
const SyncSettings = /*#__PURE__*/React.forwardRef(function SyncSettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M15 24L15 22 11.4 22 22 11.4 22 15 24 15 24 8 17 8 17 10 20.6 10 10 20.6 10 17 8 17 8 24 15 24z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m25,20v2h3c1.1,0,2-.9,2-2v-3h-2v3h-3Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M28 10H30V14H28z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m25,2v2h3v3h2v-3c0-1.1-.9-2-2-2h-3Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M18 2H22V4H18z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m10,4v3h2v-3h3V2h-3c-1.1,0-2,.9-2,2Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12,10H4c-1.1,0-2,.9-2,2v16c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2v-8h-2v8H4V12h8v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SyncSettings.propTypes = iconPropTypes;
}
const SysProvision = /*#__PURE__*/React.forwardRef(function SysProvision({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L21 30 30 25 21 20z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SysProvision.propTypes = iconPropTypes;
}
const SysplexDistributor = /*#__PURE__*/React.forwardRef(function SysplexDistributor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 26H8V30H4z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M14 26H18V30H14z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M24 26H28V30H24z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m25,18h-8v-2h-2v2H7c-1.1028,0-2,.8975-2,2v4h2v-4h8v4h2v-4h8v4h2v-4c0-1.1025-.8972-2-2-2Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,2h-8c-1.1028,0-2,.8975-2,2v8c0,1.1025.8972,2,2,2h8c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2Zm-1.4141,2l-6.5859,6.5859v-6.5859h6.5859Zm-5.1719,8l6.5862-6.5859.001,6.5859h-6.5872Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SysplexDistributor.propTypes = iconPropTypes;
}
const QT = /*#__PURE__*/React.forwardRef(function QT({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QT.propTypes = iconPropTypes;
}
const QTAlt = /*#__PURE__*/React.forwardRef(function QTAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QTAlt.propTypes = iconPropTypes;
}
const Table = /*#__PURE__*/React.forwardRef(function Table({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Table.propTypes = iconPropTypes;
}
const TableAlias = /*#__PURE__*/React.forwardRef(function TableAlias({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M12,29H5a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2h7a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,12,29ZM5,20v7h7V20Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TableAlias.propTypes = iconPropTypes;
}
const TableBuilt = /*#__PURE__*/React.forwardRef(function TableBuilt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H24V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V22a2.0025,2.0025,0,0,0,2,2H8v4a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM22,22H14V17h8Zm0-7H14V10h8ZM12,15H4V10h8ZM22,4V8H4V4ZM4,22V17h8v5Zm24,6H10V24H22a2.0025,2.0025,0,0,0,2-2V10h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TableBuilt.propTypes = iconPropTypes;
}
const TableShortcut = /*#__PURE__*/React.forwardRef(function TableShortcut({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18L5 20 10.586 20 3 27.586 4.414 29 12 21.414 12 27 14 27 14 18 5 18z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V15H5V11H15v4h2V11H27v7H17v2H27v7H17v2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TableShortcut.propTypes = iconPropTypes;
}
const TableSplit = /*#__PURE__*/React.forwardRef(function TableSplit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TableSplit.propTypes = iconPropTypes;
}
const TableOfContents = /*#__PURE__*/React.forwardRef(function TableOfContents({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H22V8H4z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H22V14H4z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H22V20H4z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H22V26H4z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6H28V8H26z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H28V14H26z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H28V20H26z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24H28V26H26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TableOfContents.propTypes = iconPropTypes;
}
const Tablet = /*#__PURE__*/React.forwardRef(function Tablet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22H17V28H15z",
    transform: "rotate(90 16 25)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tablet.propTypes = iconPropTypes;
}
const TabletLandscape = /*#__PURE__*/React.forwardRef(function TabletLandscape({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13H26V19H24z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TabletLandscape.propTypes = iconPropTypes;
}
const Tag = /*#__PURE__*/React.forwardRef(function Tag({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6436,29.4145,2.5858,15.3555A2,2,0,0,1,2,13.9414V4A2,2,0,0,1,4,2h9.9413a2,2,0,0,1,1.4142.5858L29.4144,16.6436a2.0005,2.0005,0,0,1,0,2.8285l-9.9424,9.9425a2.0008,2.0008,0,0,1-2.8285,0ZM4,4v9.9417L18.0578,28,28,18.0579,13.9416,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tag.propTypes = iconPropTypes;
}
const TagEdit = /*#__PURE__*/React.forwardRef(function TagEdit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,7.293l-3-3a.9994.9994,0,0,0-1.414,0L16,13.5859V18h4.4141L29.707,8.707A.9994.9994,0,0,0,29.707,7.293ZM19.5859,16H18V14.4141l5-5L24.5859,11ZM26,9.5859,24.4141,8,26,6.4141,27.5859,8Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0059,14.2354l-1.4141,1.414L28,18.0576,18.0579,28,4,13.9414V4h9.9417l4.4067,4.4067,1.4141-1.4145-4.407-4.4063A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TagEdit.propTypes = iconPropTypes;
}
const TagExport = /*#__PURE__*/React.forwardRef(function TagExport({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M31 18L25 12 23.586 13.414 27.172 17 17 17 17 19 27.172 19 23.586 22.586 25 24 31 18z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0593,25l-3.0014,3L4,13.9414V4h9.9417l7,7,1.4143-1.414-7.001-7A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l3.0014-3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TagExport.propTypes = iconPropTypes;
}
const TagGroup = /*#__PURE__*/React.forwardRef(function TagGroup({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "14",
    r: "2"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TagGroup.propTypes = iconPropTypes;
}
const TagImport = /*#__PURE__*/React.forwardRef(function TagImport({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18L22 12 23.414 13.414 19.828 17 30 17 30 19 19.828 19 23.414 22.586 22 24 16 18z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0586,26l-2.0007,2L4,13.9414V4h9.9417l6,6,1.4143-1.414-6.001-6A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141L16.6436,29.4146a2.001,2.001,0,0,0,2.8286,0l2.0006-2.0007Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TagImport.propTypes = iconPropTypes;
}
const TagNone = /*#__PURE__*/React.forwardRef(function TagNone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M23.092,10.3218,30,3.4141,28.5859,2,2,28.5859,3.4141,30l6.9077-6.9077,6.3218,6.3223a2.001,2.001,0,0,0,2.8286,0l9.9424-9.9424a2.001,2.001,0,0,0,0-2.8286ZM18.0579,28l-6.3218-6.3223,9.9419-9.9419L28,18.0576Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,14Zm0-6a2,2,0,1,0,1.998,2.0044A2.002,2.002,0,0,0,10,8Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4927,20.2627l1.414-1.4141L4,13.9414V4h9.9417l4.9069,4.9067,1.4141-1.414L15.3555,2.5859A2,2,0,0,0,13.9414,2H4A2,2,0,0,0,2,4v9.9414a2,2,0,0,0,.5857,1.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TagNone.propTypes = iconPropTypes;
}
const Tank = /*#__PURE__*/React.forwardRef(function Tank({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13V11H18.6182l-.7237-1.4473A1,1,0,0,0,17,9H9a1,1,0,0,0-1,1v5H4v2H22.6379l3.6,3H3a1,1,0,0,0-1,1v2a5.0057,5.0057,0,0,0,5,5H25a5.0057,5.0057,0,0,0,5-5V21a1.0011,1.0011,0,0,0-.36-.7686l-6-5A1.0015,1.0015,0,0,0,23,15H20.6182l-1-2ZM28,23a3.0033,3.0033,0,0,1-3,3H7a3.0033,3.0033,0,0,1-3-3V22H28ZM10,15V11h6.3821l2,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tank.propTypes = iconPropTypes;
}
const Task = /*#__PURE__*/React.forwardRef(function Task({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Task.propTypes = iconPropTypes;
}
const TaskAdd = /*#__PURE__*/React.forwardRef(function TaskAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24L27 24 27 20 25 20 25 24 21 24 21 26 25 26 25 30 27 30 27 26 31 26 31 24z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2H17V28H7V7h3v3H22V7h3v9h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskAdd.propTypes = iconPropTypes;
}
const TaskApproved = /*#__PURE__*/React.forwardRef(function TaskApproved({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20A6,6,0,1,0,20,24.46V32l4-1.8936L28,32V24.46A5.98,5.98,0,0,0,30,20Zm-4,8.84-2-.9467L22,28.84V25.65a5.8877,5.8877,0,0,0,4,0ZM24,24a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskApproved.propTypes = iconPropTypes;
}
const TaskAssetView = /*#__PURE__*/React.forwardRef(function TaskAssetView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,26A3.5,3.5,0,1,1,26,22.5,3.5041,3.5041,0,0,1,22.5,26Zm0-5A1.5,1.5,0,1,0,24,22.5,1.5017,1.5017,0,0,0,22.5,21Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,31A8.5,8.5,0,1,1,31,22.5,8.51,8.51,0,0,1,22.5,31Zm0-15A6.5,6.5,0,1,0,29,22.5,6.5074,6.5074,0,0,0,22.5,16Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h5V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskAssetView.propTypes = iconPropTypes;
}
const TaskComplete = /*#__PURE__*/React.forwardRef(function TaskComplete({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V18h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskComplete.propTypes = iconPropTypes;
}
const TaskLocation = /*#__PURE__*/React.forwardRef(function TaskLocation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "21",
    r: "2"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskLocation.propTypes = iconPropTypes;
}
const TaskRemove = /*#__PURE__*/React.forwardRef(function TaskRemove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskRemove.propTypes = iconPropTypes;
}
const TaskSettings = /*#__PURE__*/React.forwardRef(function TaskSettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskSettings.propTypes = iconPropTypes;
}
const TaskStar = /*#__PURE__*/React.forwardRef(function TaskStar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17L25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskStar.propTypes = iconPropTypes;
}
const TaskTools = /*#__PURE__*/React.forwardRef(function TaskTools({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskTools.propTypes = iconPropTypes;
}
const TaskView = /*#__PURE__*/React.forwardRef(function TaskView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TaskView.propTypes = iconPropTypes;
}
const Taste = /*#__PURE__*/React.forwardRef(function Taste({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4V6H8v8a8,8,0,0,0,16,0V6h4V4ZM22,14a6,6,0,0,1-12,0V6h5v8h2V6h5Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M11 26H13V28H11z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24H9V26H7z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24H17V26H15z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H21V28H19z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M23 24H25V26H23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Taste.propTypes = iconPropTypes;
}
const Taxi = /*#__PURE__*/React.forwardRef(function Taxi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Taxi.propTypes = iconPropTypes;
}

export { QT, QTAlt, SoilMoistureGlobal, SoilTemperature, SoilTemperatureField, SoilTemperatureGlobal, SolarPanel, SortAscending, SortDescending, SortRemove, SortingAToZ, SortingHighestToLowestNumber, SortingLowestToHighestNumber, SortingZToA, SpellCheck, Split, SplitScreen, SprayPaint, Sprout, SpyreAccelerator, Sql, SquareFill, SquareOutline, SquareSolid, StackLimitation, Stamp, Star, StarFilled, StarHalf, StarReview, StayInside, StemLeafPlot, Stethoscope, Stickies, Stop, StopFilled, StopFilledAlt, StopOutline, StopOutlineFilled, StopSign, StopSignFilled, StoragePool, StorageRequest, Store, StormTracker, StrategyPlay, Strawberry, StringInteger, StringText, Subclassification, Subdirectory, Subflow, SubflowLocal, SubjectDefinition, SubjectUsage, SubnetAclRules, Subsetting, Subtract, SubtractAlt, SubtractFilled, SubtractLarge, Succession, SuccessionFlowConnection, SummaryKpi, SummaryKpiMirror, Sun, Sunrise, Sunset, SupportVectorMachine, Sustainability, Svg, Swim, SwimlaneDVertical, SwitchLayer_2, SwitchLayer_3, Switcher, SyncSettings, SysProvision, SysplexDistributor, Table, TableAlias, TableBuilt, TableOfContents, TableShortcut, TableSplit, Tablet, TabletLandscape, Tag, TagEdit, TagExport, TagGroup, TagImport, TagNone, Tank, Task, TaskAdd, TaskApproved, TaskAssetView, TaskComplete, TaskLocation, TaskRemove, TaskSettings, TaskStar, TaskTools, TaskView, Taste, Taxi, WatsonHealthSpineLabel, WatsonHealthSplitDiscard, WatsonHealthStackedMove, WatsonHealthStackedScrolling_1, WatsonHealthStackedScrolling_2, WatsonHealthStatusAcknowledge, WatsonHealthStatusChange, WatsonHealthStatusPartialFail, WatsonHealthStatusResolved, WatsonHealthStressBreathEditor, WatsonHealthStudyNext, WatsonHealthStudyPrevious, WatsonHealthStudyRead, WatsonHealthStudySkip, WatsonHealthStudyTransfer, WatsonHealthStudyUnread, WatsonHealthStudyView, WatsonHealthSubVolume };
